import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import Tooltip from "rc-tooltip";

export const HomeCertification = () => {
  const { t } = useTranslation();
  // const nav = useNavigate();
  const certifications = [
    {
      imgUrl: "//files.authing.co/authing-website/home-logo-iso.png",
      alt:
        "ISO 9001 质量体系认证 ISO/IEC 20000-1 服务管理体系 ISO 27001 信息安全管理体系",
      tooltip: (
        <div style={{ textAlign: "center" }}>
          <div>{t("page.other.brand.item-one")}</div>
          <div>{t("page.other.brand.item-one1")}</div>
          <div style={{ paddingBottom: 8 }}>
            {t("page.other.brand.item-one2")}
          </div>
        </div>
      ),
    },
    {
      imgUrl: "//files.authing.co/authing-website/home-logo-jdpr.png",
      alt: "通用数据保护条例",
      tooltip: t("page.other.brand.item-two"),
    },
    {
      imgUrl: "//files.authing.co/authing-website/home-logo-soc.png",
      alt: "中国网络安全产业白皮书",
      tooltip: t("page.other.brand.item-tree"),
    },
    {
      imgUrl: "//files.authing.co/authing-website/home-logo-djcp.png",
      alt: "中国网络安全产业白皮书",
      tooltip: t("page.other.brand.item-four"),
    },
    {
      imgUrl:
        "//files.authing.co/authing-website/hone-logo-country-height-tech.png",
      alt: "国家高新技术企业",
      tooltip: t("page.other.brand.item-five"),
    },
  ];
  return (
    <div className="home-others">
      <section className="inner">
        <div className="certification-title">
          <div className="line-top"></div>
          <div className="line-top-text">{t("home.certification.title")}</div>
          <div className="line-top"></div>
        </div>
        <div className="brand-warp">
          <div className="in-inner">
            {certifications.map((item, index) => (
              <Tooltip
                key={`${item.imgUrl}-${index}`}
                placement="bottom"
                mouseLeaveDelay={0.001}
                trigger={["hover"]}
                overlay={item.tooltip}
                overlayInnerStyle={{
                  // marginBottom: 0,
                  paddingBottom: 0,
                  // paddingTop: 18,
                }}
                overlayStyle={
                  {
                    // margin: "0px",
                  }
                }
              >
                <div className="item">
                  <div className="brand">
                    <img src={item.imgUrl} alt={item.alt} />
                  </div>
                </div>
              </Tooltip>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};
